import { render, staticRenderFns } from "./BusinessProductOrderingHoursSummary.vue?vue&type=template&id=10041804&scoped=true&"
import script from "./BusinessProductOrderingHoursSummary.vue?vue&type=script&lang=ts&"
export * from "./BusinessProductOrderingHoursSummary.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProductOrderingHoursSummary.vue?vue&type=style&index=0&id=10041804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10041804",
  null
  
)

export default component.exports